<template>
  <div class="rounded" style="border: 2px solid #bfdbfe">
    <!-- Header -->
    <div class="d-flex align-center pa-3" style="background: linear-gradient(135deg, #eff6ff, #eef2ff); border-radius: 6px 6px 0 0">
      <div class="d-flex align-center justify-center mr-2 flex-shrink-0" style="width: 28px; height: 28px; border-radius: 50%; background: #1d4ed8">
        <v-icon color="white" small>mdi-calculator</v-icon>
      </div>
      <div>
        <p class="body-2 font-weight-medium ma-0" style="color: #1e3a8a">Custo Estimado desta Meta</p>
        <p v-if="custoEstimado.total > 0" class="caption ma-0" style="color: #2563eb">{{ descricaoPreenchido }}</p>
      </div>
    </div>

    <!-- Estado vazio -->
    <div v-if="custoEstimado.total === 0" class="pa-3" style="background: white; border-radius: 0 0 6px 6px">
      <v-alert type="info" dense text class="caption mb-0">{{ descricaoVazio }}</v-alert>
    </div>

    <template v-else>
      <!-- Detalhamento por item -->
      <div
        v-if="linhas.length > 0"
        class="px-3 pt-3 pb-2"
        style="background: white; border-top: 1px solid #bfdbfe"
      >
        <p class="caption font-weight-bold text-uppercase ma-0 mb-2" style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.55)">Simulação por item</p>
        <div
          v-for="(linha, i) in linhas"
          :key="i"
          class="d-flex justify-space-between align-center py-1"
          :style="i < linhas.length - 1 ? 'border-bottom: 1px solid rgba(0,0,0,0.06)' : ''"
        >
          <div class="d-flex align-center" style="gap: 4px; min-width: 0">
            <span class="caption" style="color: rgba(0,0,0,0.75); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 260px">{{ linha.label }}</span>
            <span v-if="linha.detalhe" class="caption" style="color: rgba(0,0,0,0.4); flex-shrink: 0">— {{ linha.detalhe }}</span>
          </div>
          <span class="caption font-weight-medium ml-3" style="color: #1d4ed8; flex-shrink: 0">{{ formatarMoeda(linha.valor) }}</span>
        </div>
      </div>

      <!-- Totais -->
      <div class="pa-4" style="background: linear-gradient(135deg, #eff6ff, #eef2ff); border-top: 1px solid #bfdbfe" :style="linhas.length === 0 ? 'border-radius: 0 0 6px 6px' : 'border-radius: 0 0 6px 6px'">
        <div v-if="custoEstimado.porColaborador !== null" class="d-flex justify-space-between align-center mb-2">
          <span class="body-2" style="color: #1d4ed8">{{ custoEstimado.nSemanas > 1 ? "Por colaborador / por semana" : "Por colaborador" }}</span>
          <span class="body-2 font-weight-bold" style="color: #1e3a8a">{{ formatarMoeda(custoEstimado.porColaborador) }}</span>
        </div>
        <div v-if="custoEstimado.nSemanas > 1 && custoEstimado.porColaborador !== null" class="d-flex justify-space-between align-center mb-2">
          <span class="body-2" style="color: #1d4ed8">Por colaborador (todas as {{ custoEstimado.nSemanas }} semanas)</span>
          <span class="body-2 font-weight-bold" style="color: #1e3a8a">{{ formatarMoeda(custoEstimado.porColaborador * custoEstimado.nSemanas) }}</span>
        </div>
        <div class="d-flex justify-space-between align-center">
          <div>
            <span class="body-2" style="color: #1d4ed8">Total máximo</span>
            <span class="ml-1 caption" style="color: #60a5fa">
              <template v-if="custoEstimado.nSemanas > 1">({{ custoEstimado.nSemanas }} semanas × {{ nColaboradores }} colab.)</template>
              <template v-else>({{ nColaboradores }} colaborador{{ nColaboradores !== 1 ? "es" : "" }})</template>
            </span>
          </div>
          <span class="headline font-weight-bold" style="color: #1e3a8a">{{ formatarMoeda(custoEstimado.total) }}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import currencyMixin from "@/mixins/currencyMixin";

export default {
  name: "CustoEstimadoCard",

  mixins: [currencyMixin],

  props: {
    custoEstimado: {
      type: Object,
      default: () => ({ porColaborador: 0, total: 0, nSemanas: 1, linhas: [] })
    },
    nColaboradores: { type: Number, default: 0 },
    descricaoPreenchido: { type: String, default: "" },
    descricaoVazio: { type: String, default: "Preencha os valores acima para visualizar a simulação de custo." }
  },

  computed: {
    linhas() {
      return this.custoEstimado.linhas || [];
    }
  }
};
</script>
